import { Component, inject, Inject, InjectionToken, OnInit } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { TAuthProvider } from '../../core/auth/auth.interface';
import { ActivatedRoute, Router } from '@angular/router';
// Service
import { LoggingService } from '../../core/utils/logging.service';
// PrimeNG
import { ButtonModule } from 'primeng/button';
// Component
import { LinkAccountComponent } from '../../pattern/link-account/link-account.component';

export const ROUTE_TOKEN = new InjectionToken('ROUTE_TOKEN');

@Component({
  selector: 'app-link-account-layout',
  imports: [ButtonModule, LinkAccountComponent],
  providers: [
    {
      provide: ROUTE_TOKEN,
      useValue: 'test',
    },
  ],
  template: `
    <div class="flex flex-column h-screen">
      <div class="flex h-full w-full justify-content-center align-items-center bg-landing">
        <div
          class="flex flex-column gap-4 justify-content-center align-items-center border-round-2xl bg-white p-5"
          style="width: 494px; height: 566px;"
        >
          @if (redirectUrl && socialProvider) {
            <app-link-account [redirectUrl]="redirectUrl" [socialProvider]="socialProvider"></app-link-account>
            <div class="w-full">
              <p-button label="Cancel" styleClass="w-full" [text]="true" (click)="cancelRouteHandler()"></p-button>
            </div>
          } @else {
            <div>Loading...</div>
          }
        </div>
      </div>
    </div>
  `,
  styles: ``,
})
export class LinkAccountLayoutComponent implements OnInit {
  private auth0 = inject(AuthService);
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly loggingService = inject(LoggingService);

  redirectUrl!: string;
  socialProvider!: TAuthProvider;

  constructor(@Inject(ROUTE_TOKEN) private token: string) {
    this.loggingService.error('@@@LinkAccountComponent', this.token);
  }

  public ngOnInit() {
    this.loggingService.log('ngOnInit');
    const queryParams = this.route.snapshot.queryParams;
    this.loggingService.log('queryParams', queryParams);
    this.auth0.appState$.subscribe({
      next: (d) => {
        this.loggingService.log('state', d);
        this.redirectUrl = d['callToRedirectRoute'];
        this.socialProvider = d['socialProvider'] as TAuthProvider;
      },
      error: (e) => {
        this.loggingService.error('error-appstate', e);
      },
    });
  }

  async cancelRouteHandler() {
    await this.router.navigateByUrl(new URL(this.redirectUrl).pathname, {
      replaceUrl: true,
    });
  }
}
